import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";

interface InitialState {
  thirdPartyDeviceProviderList: any;
  thirdPartyDevices: any;
  loader: boolean;
  providerLoader: boolean;
  thirdPartyDeviceReading: any
}

const initialState: InitialState = {
  thirdPartyDeviceProviderList: [],
  thirdPartyDevices: [],
  loader: false,
  providerLoader: false,
  thirdPartyDeviceReading: {}
};

const thirdPartyDeviceSlice = createSlice({
  name: "thirdPartyDevice",
  initialState,
  reducers: {
    thirdPartyDeviceProviderList: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
      ...state,
      thirdPartyDeviceProviderList: action.payload,
    }),
    setDeviceList: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
      ...state,
      thirdPartyDevices: action.payload,
    }),
    setLoader: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
      ...state,
      loader: action.payload,
    }),
    setProviderLoader: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
      ...state,
      providerLoader: action.payload,
    }),
    setThirdPartyDeviceReading: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
      ...state,
      thirdPartyDeviceReading: action.payload,
    })
  },
});

export const { thirdPartyDeviceProviderList, setDeviceList, setLoader, setProviderLoader, setThirdPartyDeviceReading } = thirdPartyDeviceSlice.actions;

export default thirdPartyDeviceSlice.reducer;
